import { render } from "./VistaHistorialCentros.vue?vue&type=template&id=0a85584e&scoped=true"
import script from "./VistaHistorialCentros.vue?vue&type=script&lang=js"
export * from "./VistaHistorialCentros.vue?vue&type=script&lang=js"

import "./VistaHistorialCentros.vue?vue&type=style&index=0&id=0a85584e&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a85584e"]])

export default __exports__